import { csrf } from "~/api2/utils/configs"

export interface ReservationImportResult {
  created: {
    row: number
    reservation_id: string
    guest_first_name: string
    guest_last_name: string
    site_name: string
    arrival_date: string
    departure_date: string
    import_data: {
      guest_first_name: string
      guest_last_name: string
      site_name: string
      arrival_date: string
      departure_date: string
    }
  }[]
  errors: {
    row: number
    message: string
    guest_first_name: string
    guest_last_name: string
    site_name: string
    arrival_date: string
    departure_date: string
  }[]
}

const importCsv = async (campId: string, file: File): Promise<ReservationImportResult> => {
  const response = await fetch(`/api/onboarding/reservations?camp_id=${campId}`, {
    method: "POST",
    headers: {
      "Content-Type": "text/csv",
      "X-CSRF-Token": csrf,
    },
    body: file,
  })

  if (!response.ok) {
    try {
      const data = await response.json()
      throw new Error(data.error || "Import failed")
    } catch (err: any) {
      throw new Error(err.message || response.statusText)
    }
  }

  return response.json()
}

const ReservationImport = { importCsv }

export default ReservationImport
export type tReservationImportResult = ReservationImportResult
